<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background-image: url(\"https:\/\/api.saratavakoli-master.ir\/storage\/assets\/patern.png\");\nbackground-repeat: no-repeat;\nbackground-position:right;\n\n"' class="bg-primary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"\n"' class="container pb-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="mx-auto text-center" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"font-size:45px;\ntext-shadow: black 1px 0 15px;"' class="pt-5 pb-3 text-white" >
                <template #default>بزرگترین سمینار ریمو خوزستان   </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='"text-shadow: black 1px 0 10px;"' class="text-center text-white" >
                <template #default>من سارا توکلی هستم

مدرس و متخصص لاین آرایش دائم 

که از سال 98 بطور تخصصی فعالیتم را آغاز کردم 

به صورت تخصصی در حیطه آموزش و خدمات آرایش دائم (PMU) چشم و ابرو لب ، میکرو اسکالپ در ناحیه سر (SMP) و ریمو تتو های قدیمی فعالیت دارم   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"border-radius:25px;\nbackground-image: url(\"https:\/\/api.saratavakoli-master.ir\/storage\/assets\/Mandala-8.webp\");\nbackground-repeat: no-repeat;\nbackground-color:#ffffffcf;\n\n"' class="row  p-4 border shadow " >
                <template #default>   <m-video v-bind='{...{"controls":true,"videoSrc":"https:\/\/api.saratavakoli-master.ir\/storage\/assets\/Img 6364.mp4","autoplay":false,"muted":false,"loop":false},...{}}' :style='"border-radius:1pc;\npadding:2px;\nborder:3px solid black;"' class="col-lg-4 shadow" ></m-video><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-8  p-2 mt-2 col-md-12" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"background:#ffffff;\nborder-radius:15px;"' class="h-100 shadow border" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"font-size:25px;"' class="pt-3 text-center" >
                <template #default>سر فصل های آموزشی سمینار vip ریمو    </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>۱.مشاوره ی صحیح و انتخاب صحیح ریموور متناسب با نوع تتو   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 2. اموزش کار با انواع ریموور های اسیدی    </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 3. باید ها و نباید های قبل و بعد از ریمو    </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 4. معرفی ابزار کار وفروشگاه معتبر   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 5. پیگمنتولوژی و لیزر شناسی مرتبط با ریمو    </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 6. آموزش کوکتل تراپی و آنزیم تراپی   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 7. آموزش ریمو ابرو چشم و لب   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 8. موارد منع ریمو    </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 9. مراقبتهای قبل و بعد از ریمو    </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 10. امکان شرکت در دوره ی کارورزی   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 11. اموزش ریمو اورژانسی   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 12. پشتیبانی سه ماهه   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 13. ارائه جزوه جامع   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 14. با حضور پزشک   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 15. دریافت سرتیفیکیت گذر دوره   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default> 16. دریافت مدرک معتبر دانشگاه علمی کاربردی   </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"background: #d0f4de;\n"' class="container-fluid " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"\nbackground:var(--primary) ;\nbackground-image: url(\"https:\/\/api.rastavisa.com\/storage\/contents\/bgpatern2.png\");\nbackground-repeat: no-repeat;\nbackground-size: cover;\n"' class="row d-flex  justify-content-center align-items-center p-5\n" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class=" col-md-6 col-12 text-center p-4" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"\n  text-decoration: line-through;\n\n"' class="text-danger" >
                <template #default>8.000.000 تومان   </template>
                </m-h1><m-h1 v-bind='{...{},...{}}' :style='"color: #000 !important;\n\n\n"' class="" >
                <template #default>798.000 تومان   </template>
                </m-h1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-md-6 col-12 text-center pb-3" >
                <template #default>   <m-product-add-to-cart-2 v-bind='{...{"productLink":"\u062b\u0628\u062a-\u0646\u0627\u0645-\u0633\u0645\u06cc\u0646\u0627\u0631-\u0631\u06cc\u0645\u0648","advanceDescription":true,"advanceDescriptionInputs":"[ { \"name\": \"\u0633\u0627\u0628\u0642\u0647 \u06a9\u0627\u0631\u06cc \u062f\u0631 \u0632\u0645\u06cc\u0646\u0647 \u0631\u06cc\u0645\u0648\", \"placeholder\": \"\", \"regex\": \"\", \"required\": true, \"type\": \"selectbox\", \"options\": [ \"\u062f\u0627\u0631\u0645\", \"\u0646\u062f\u0627\u0631\u0645\" ] }, { \"name\": \"\u0645\u0639\u0631\u0641\", \"placeholder\": \"\", \"regex\": \"\", \"required\": true, \"type\": \"text\" } ]","defaultGate":"zarinpal"},...{}}' :style='""' class="" ></m-product-add-to-cart-2></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mVideo from '@moeinmdn/miw-alpha-components/src/package/Tags/Video'; import mProductAddToCart2 from '@moeinmdn/miw-alpha-components/src/package/Tool/ProductAddToCart/ProductAddToCart2';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mP,mVideo,mProductAddToCart2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
